import { GMedication } from '../store/db';
import { GET_SNACKING_QUESTIONS } from './constants';
import { CodedMedications } from './fetchDrugSearch';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    status: string;
    questions: SnackingQuestion[];
    doctorProfile?: DoctorProfile;
    version: string;
    error?: string;
}

export type SnackingQuestion = {
    q_id: string;
    q_type: string;
    med: GMedication;
    suggestions: CodedMedications[];
    fCount: number;
};

export interface DoctorProfile {
    id: string;
    name: string;
    img: string;
    speciality: string;
    experience: string;
    title: string;
    drugsReviewed: string;
    acceptanceRate: string;
    profileUrl: string;
}

export default (version: string): Promise<Response> =>
    fetchWithRefresh(GET_SNACKING_QUESTIONS(version)).then((res) => res.json());
